import { render, staticRenderFns } from "./PersistMotoristaCancelamentoCargaView.vue?vue&type=template&id=0637d160&"
import script from "./PersistMotoristaCancelamentoCargaView.vue?vue&type=script&lang=ts&"
export * from "./PersistMotoristaCancelamentoCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports